module.exports = __webpack_public_path__ + "css/corner.svg?f8c0c0785e17fb0870fbb347f10e7ead";